module.exports = "/packs/complete_tutorial-47b2861cf3831747c1c34b5db5384eea.svg";